import { Button } from 'tdesign-react';
import { useNavigate } from 'react-router-dom';
import { clearPortalAuth } from '@/utils/auth';
import './Login.css';

/**
 * 无访问权限页
 *
 * 触发条件：登录后访问业务接口时，后端中间件返回 403
 * （例如：账号被管理员驳回、被删除、或审批状态从 APPROVED 改回 PENDING）
 *
 * 注：扫码登录本身的「审批中 / 已拒绝」状态由登录页直接展示，不会跳到本页。
 */
const NoPermission = () => {
  const navigate = useNavigate();

  const handleRelogin = () => {
    clearPortalAuth();
    navigate('/portal/login', { replace: true });
  };

  return (
    <div className="portal-no-permission">
      <div className="portal-no-permission-card">
        <div className="portal-no-permission-emoji">🔒</div>
        <div className="portal-no-permission-title">暂无访问权限</div>
        <div className="portal-no-permission-desc">
          您的账号目前没有访问权限，
          <br />
          可能已被管理员调整状态，请联系管理员处理或重新登录。
        </div>
        <div className="portal-no-permission-actions">
          <Button theme="primary" onClick={handleRelogin}>
            返回登录
          </Button>
        </div>
      </div>
    </div>
  );
};

export default NoPermission;
